import React from 'react';
import PropTypes from 'prop-types';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import useCountdown from '../useCountdown';
import { Container, Time, Title } from './styles';

function CountdownHalloween({ data, styles }) {
  const haveTitle = !!data.title;

  const fontFamilyTimer = FONT_FAMILY[styles?.timer?.font || 'creepster'];
  const fontFamilyTitle = FONT_FAMILY[styles?.title?.font || 'creepster'];

  const [hours, minutes, seconds] = useCountdown({
    audioUrl: data.audioUrl,
    status: data.status,
    time: data.time,
  });

  return (
    <>
      <FontFamilyHeader family={fontFamilyTimer} />
      <FontFamilyHeader family={fontFamilyTitle} />
      <Container>
        <Time
          style={{
            color: styles?.timer?.color,
            fontFamily: fontFamilyTimer?.family,
            fontSize: styles?.timer?.size,
            letterSpacing: styles?.timer?.letterSpacing,
            lineHeight: styles?.timer?.size
              ? `${styles?.timer?.size}px`
              : undefined,
          }}
        >
          {`${hours}:${minutes}:${seconds}`}
        </Time>
        <svg
          width="355"
          height="216"
          viewBox="0 0 355 216"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31 96L334.5 98L311 212L39.5 215.5L31 96Z"
            fill={styles?.timer?.background}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.199 34.966L5.00103 39.5799L3.53149 30.9628L15.4146 24.5024C13.3637 20.5239 9.98864 11.9995 12.8954 9.7303C15.8021 7.46105 19.4711 6.81423 20.9423 6.77447L26.5843 19.4305L35.8169 17.856L38.1262 31.3971C35.2666 30.7235 29.8698 30.5249 31.16 35.1187C32.0163 38.1679 33.3278 41.5953 34.4055 44.1847C39.4198 42.7054 44.25 41.8829 47.684 41.5627L55.7809 51.8999C54.2795 53.0005 51.7945 56.3802 53.8652 61.0943C55.936 65.8084 55.9876 70.4446 55.7546 72.1734C58.3264 73.635 63.6197 78.1796 64.2189 84.6648C69.8873 90.6656 80.5617 103.984 77.9126 109.249C75.2636 114.515 47.3392 118.158 33.7082 119.321L27.663 95.0161C20.5712 88.0969 7.64913 71.2562 12.6954 59.2476C14.6143 54.6812 18.7508 51.1593 23.6666 48.4988C22.5467 45.5211 21.4482 41.6059 21.5743 38.337C21.7614 33.4912 18.7354 34.0706 17.199 34.966Z"
            fill={styles?.timer?.background}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M341.331 30.8408L348.846 34.3047L349.5 25.5878L342.126 20.2559C343.815 16.1041 346.406 7.30296 343.248 5.31261C341.05 3.92725 338.597 5.24114 336.807 6.2005C336.025 6.61946 335.369 6.9708 334.916 7.0002L330.5 18.5L316 16.5L318.5 27.0878C321.326 26.1521 328 29.5 328 29.5C331.601 28.8818 327.664 36.903 325.259 41.7007C319.888 40.6275 314.745 40.235 311.144 40.2343L303.955 51.2782C302.228 53.6171 302.032 54.3161 301.497 56.2262C301.272 57.0313 300.986 58.0514 300.5 59.5001C298.9 64.2692 300.04 69.0649 300.47 70.8725C300.48 70.9168 300.491 70.9594 300.5 71.0001C298.412 72.4386 298.474 76.608 298.553 81.8222C298.567 82.7474 298.581 83.7054 298.584 84.687C293.432 91.1877 283.924 105.439 287.11 110.437C290.296 115.435 313.605 131.105 327.499 131L336.543 91.6075C343.045 84.0602 354.486 66.0931 348.226 54.6028C345.753 50.0645 340.97 46.87 335.487 44.6656C335.488 44.6408 335.489 44.616 335.49 44.5911C335.555 42.7342 335.641 40.2961 336.5 36.5C337.571 31.7671 339.691 30.0915 341.331 30.8408Z"
            fill={styles?.timer?.background}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M65.2116 84.7929C64.706 63.457 79.9918 60.1357 87.6979 61.142C87.0239 57.301 86.5596 49.7073 90.0946 50.0604C93.6297 50.4135 94.3963 58.324 94.3377 62.2351C125.379 68.5676 113.315 91.7679 103.403 102.576C90.8834 105.539 65.7172 106.129 65.2116 84.7929ZM77.5397 84.0629L72.7833 79.2819C71.2064 86.9256 75.7307 91.1066 78.19 92.2416L79.2553 90.6625L81.3852 92.7041L79.8482 94.0859C80.1078 95.4221 86.0785 97.1604 89.0314 97.8625L89.4068 95.3341L91.852 95.6535C91.3577 96.2069 90.6184 97.4819 91.6158 98.1547C92.6131 98.8276 96.9297 97.6278 98.9633 96.9438L97.999 95.3258L99.7873 93.7506L101.502 95.5119C105.101 93.2237 108.22 87.3459 108.174 85.6216C108.137 84.2422 104.389 86.2126 102.52 87.3702L102.591 89.5951L100.422 89.5831C100.51 88.7958 100.501 87.3146 99.765 87.6887C99.0288 88.0628 94.3549 88.8361 92.11 89.176L91.1008 90.672L89.738 90.7201L88.6074 88.9899L87.0283 87.9246L86.5158 90.1185L84.1886 88.5485C84.4316 88.1884 84.8344 87.412 84.502 87.1877C84.1695 86.9634 81.0518 85.9082 79.5344 85.4086L78.1386 86.402L76.6426 85.3927L77.5397 84.0629ZM77.4228 80.1136C75.6911 78.1391 73.5813 73.7972 78.9955 72.2253L88.7196 78.7854C87.475 80.9289 83.4733 84.1955 77.4228 80.1136ZM104.203 74.4772C108.369 77.6998 106.432 82.1971 104.016 83.1796C96.808 84.3231 91.6783 81.7493 92.3264 77.9782L104.203 74.4772ZM86.8785 84.9206C87.599 83.6733 89.2844 81.2467 90.2617 81.519C91.239 81.7914 91.3192 84.7318 91.2372 86.168C91.2372 86.168 89.8219 86.5408 88.9562 86.3223C88.0072 86.0828 86.8785 84.9206 86.8785 84.9206Z"
            fill={styles?.timer?.background}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M253.872 95.3538C244.29 76.2837 256.687 66.7442 264.083 64.3581C261.831 61.1744 258.164 54.5088 261.51 53.3161C264.857 52.1235 268.933 58.9462 270.553 62.5067C301.32 54.9553 300.338 81.0862 296 95.0955C291.761 106.234 263.453 114.424 253.872 95.3538ZM264.51 89.4692L258.166 87.1816C260.009 94.7654 262.747 95.9041 265.456 95.8784L266.625 94.9166L270.151 96.6876L270.883 97.5421C271.323 98.1412 274.132 98.2171 275.834 95.4435C275.955 97.2533 279.452 97.3135 280.799 97.0285L281.907 94.2423L284.471 94.1955C284.361 94.5663 284.73 94.4531 285.276 94.2852C285.779 94.1309 286.432 93.9305 287.001 94.0175C287.721 94.1274 287.876 93.8927 288.228 93.361C288.459 93.0133 288.773 92.5387 289.384 91.9505L287.821 90.9003L288.763 88.7116L291.066 89.5705C293.341 85.9627 293.647 79.3158 292.868 77.7769C292.245 76.5458 289.699 79.9297 288.504 81.7756L289.52 83.7563L287.555 84.6731C287.507 84.535 287.481 84.4323 287.46 84.3505L287.46 84.3504L287.46 84.3504L287.46 84.3502C287.437 84.2635 287.421 84.2003 287.392 84.1434C287.315 83.9904 287.148 83.8829 286.531 83.4865C286.419 83.4149 286.293 83.3339 286.151 83.2416C285.738 82.9746 284.678 86.6749 284.678 86.6749C284.678 86.6749 280.63 87.3467 279.867 87.8598L279.595 89.6437L278.383 90.27L276.622 89.1895L274.738 88.9019L275.213 91.1042L272.438 90.6803C272.468 90.487 272.223 90.7744 271.909 91.1435C271.525 91.5941 271.037 92.1665 270.819 92.1332C270.7 92.1151 270.443 91.8843 270.098 91.5749C269.289 90.8502 268 89.6942 266.888 89.8325L266.052 91.3274L264.268 91.0549L264.51 89.4692ZM262.715 85.9493C260.305 84.905 256.037 81.1683 260.259 77.4319L271.157 81.9569C270.948 84.4267 269.93 87.0514 262.715 85.9493ZM284.512 69.4011C289.656 70.5327 289.829 75.4262 288.065 77.3475C282.038 81.464 277.771 83.237 276.744 79.551L284.512 69.4011ZM273.318 86.2506C273.436 84.815 273.922 81.9007 274.922 81.7289C275.922 81.5571 277.252 84.1808 277.792 85.5141C277.792 85.5141 276.672 86.4564 275.796 86.6291C274.836 86.8185 273.318 86.2506 273.318 86.2506Z"
            fill={styles?.timer?.background}
          />
          <path
            d="M210.332 74.8129C208.699 76.4439 213.489 78.5942 216.088 79.4655C219.228 82.2361 223.669 80.4054 223.414 86L230.741 83.6476L230.113 80.1451C230.671 79.57 231.578 77.6985 230.741 74.8129C229.694 71.2058 236.131 64.3054 233.253 63.3644C230.374 62.4234 230.741 68.1738 228.805 70.2649C227.256 71.9377 228.717 64.5493 229.642 60.646C229.834 60.0361 229.809 58.6491 228.177 57.9799C226.136 57.1435 226.921 68.6443 225.351 67.8079C223.781 66.9715 223.938 54.7911 221.688 56.098C219.437 57.4049 222.943 67.1283 221.426 68.6443C219.908 70.1603 215.931 58.9209 213.576 60.2801C211.221 61.6393 215.094 63.4167 218.077 70.2649C220.463 75.7434 217.641 76.2418 215.931 75.8061C210.018 73.3492 210.698 74.8129 210.332 74.8129Z"
            fill={styles?.timer?.background}
          />
          <path
            d="M223.497 99.1254C225.265 102.625 225.041 105.167 224.707 106L236.915 101.157C237.462 98.2401 235.248 94.8722 234.073 93.5529C234.873 90.5114 234.091 87.9108 233.6 86.9908L233.337 85.22C233.214 85.3763 232.842 85.7304 232.337 85.8971C231.832 86.0637 231.32 84.7513 231.127 84.0743C228.987 83.7965 224.308 84.1472 222.708 87.772C220.709 92.3029 223.497 92.8758 224.287 94.282C224.918 95.4069 224.023 97.9797 223.497 99.1254Z"
            fill={styles?.timer?.background}
          />
          <path
            d="M152.641 83.8129C154.409 85.4439 149.22 87.5942 146.405 88.4655C143.003 91.2361 138.192 89.4054 138.468 95L130.531 92.6476L131.211 89.1451C130.606 88.57 129.624 86.6985 130.531 83.8129C131.665 80.2058 124.692 73.3054 127.81 72.3644C130.928 71.4234 130.531 77.1738 132.628 79.2649C134.306 80.9377 132.723 73.5493 131.721 69.646C131.513 69.0361 131.54 67.6491 133.309 66.9799C135.52 66.1435 134.669 77.6443 136.37 76.8079C138.071 75.9715 137.901 63.7911 140.338 65.098C142.776 66.4049 138.978 76.1283 140.622 77.6443C142.266 79.1603 146.575 67.9209 149.126 69.2801C151.677 70.6393 147.482 72.4167 144.25 79.2649C141.665 84.7434 144.723 85.2418 146.575 84.8061C152.981 82.3492 152.244 83.8129 152.641 83.8129Z"
            fill={styles?.timer?.background}
          />
          <path
            d="M138.403 108.125C136.517 111.625 136.757 114.167 137.112 115L124.091 110.157C123.507 107.24 125.868 103.872 127.122 102.553C126.269 99.5114 127.103 96.9108 127.627 95.9908L127.908 94.22C128.039 94.3763 128.435 94.7304 128.974 94.8971C129.513 95.0637 130.059 93.7513 130.265 93.0743C132.547 92.7965 137.539 93.1472 139.245 96.772C141.377 101.303 138.403 101.876 137.561 103.282C136.888 104.407 137.842 106.98 138.403 108.125Z"
            fill={styles?.timer?.background}
          />
          <path
            d="M196.191 45.953C198.529 46.5234 195.03 50.9178 192.989 53.0437C191.354 57.1151 186.259 57.8434 189.209 62.6046L181.126 64.3903L180.025 60.9965C179.217 60.7863 177.451 59.6248 176.847 56.6609C176.093 52.956 166.65 50.2958 168.922 47.9625C171.194 45.6292 173.632 50.8524 176.48 51.6659C178.758 52.3168 173.795 46.6197 171.028 43.6897C170.551 43.2568 169.902 42.0305 171.126 40.5884C172.655 38.7858 177.481 49.2597 178.564 47.7042C179.647 46.1488 173.599 35.5745 176.364 35.5374C179.13 35.5002 180.516 45.8467 182.689 46.3768C184.861 46.907 183.188 34.987 186.078 34.9406C188.968 34.8942 186.158 38.481 186.648 46.0375C187.039 52.0826 189.956 51.0379 191.365 49.7598C195.78 44.5077 195.844 46.1452 196.191 45.953Z"
            fill={styles?.timer?.background}
          />
          <path
            d="M186.688 97.338C189.35 100.447 189.497 102.998 189.237 103.885L202.904 96.7264C203.079 93.742 195.585 70.407 193.979 69.3343C194.432 66.1773 193.083 63.7638 192.352 62.9517L191.753 61.2557C191.633 61.4338 191.251 61.8558 190.679 62.1187C190.108 62.3816 189.289 61.1865 188.95 60.556C186.372 60.6991 180.888 61.9573 179.583 65.8458C177.952 70.7063 181.347 70.728 182.51 71.9616C183.44 72.9485 187.125 96.1048 186.688 97.338Z"
            fill={styles?.timer?.background}
          />
        </svg>

        {haveTitle && (
          <Title
            style={{
              color: styles?.title?.color,
              fontFamily: fontFamilyTitle?.family,
              fontSize: styles?.title?.size,
              letterSpacing: styles?.title?.letterSpacing,
              lineHeight: styles?.title?.size
                ? `${styles?.title?.size}px`
                : undefined,
            }}
          >
            {data.title}
          </Title>
        )}
      </Container>
    </>
  );
}

CountdownHalloween.propTypes = {
  data: PropTypes.shape({
    audioUrl: PropTypes.string,
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }),
  styles: PropTypes.shape({
    timer: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    title: PropTypes.shape({
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

CountdownHalloween.defaultProps = {
  data: {
    audioUrl: null,
    status: 'paused',
    time: [],
    title: 'Time Remaining',
  },
  styles: {
    timer: {
      background: '#BB0000',
      color: '#000000',
      font: 'creepster',
      letterSpacing: 1,
      size: 80,
    },
    title: {
      color: '#BB0000',
      font: 'creepster',
      letterSpacing: 0,
      size: 30,
    },
  },
};

export default CountdownHalloween;
